import { render, staticRenderFns } from "./AdminUtilityInstantTransferFailures.vue?vue&type=template&id=3801770d&scoped=true"
import script from "./AdminUtilityInstantTransferFailures.vue?vue&type=script&lang=ts"
export * from "./AdminUtilityInstantTransferFailures.vue?vue&type=script&lang=ts"
import style0 from "./AdminUtilityInstantTransferFailures.vue?vue&type=style&index=0&id=3801770d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3801770d",
  null
  
)

export default component.exports